import React from "react";
import { default as ItemMasterParent } from "./ItemMaster";

function ItemMaster() {
  return <ItemMasterParent />;
}

export default ItemMaster;